var _defs, _rect, _circle, _circle2, _g, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOsp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    role: "img",
    "aria-label": "Onboarding Services Portal",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b3d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a8c5f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "url(#bg3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 300,
    r: 110,
    fill: "#ffffff",
    opacity: 0.07
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 50,
    r: 90,
    fill: "#ffffff",
    opacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 150,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 94,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 58,
    fontWeight: 800,
    fill: "#ffffff"
  }, "\uD83D\uDCC4"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 140,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 800,
    fill: "#ffffff"
  }, "Onboarding Services")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 182,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 800,
    fill: "#ffffff"
  }, "Portal (OSP)")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 222,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 21,
    fill: "#cdeee0"
  }, "Zero-touch loan approvals via AI document processing")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsp);
export default __webpack_public_path__ + "static/media/osp.95f3a6cbcc309f1421a58df806d61258.svg";
export { ForwardRef as ReactComponent };